import { useEffect } from 'react';

export const SEO = ({ title, description, keywords, canonical }) => {
  const siteTitle = 'Golden Tree Events';
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  
  useEffect(() => {
    // Set document title
    document.title = fullTitle;
    
    // Set meta description
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', description || '');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = description || '';
      document.head.appendChild(meta);
    }

    // Set meta keywords
    if (keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', keywords);
      } else {
        const meta = document.createElement('meta');
        meta.name = 'keywords';
        meta.content = keywords;
        document.head.appendChild(meta);
      }
    }

    // Set canonical
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (link) {
        link.setAttribute('href', canonical);
      } else {
        const linkEl = document.createElement('link');
        linkEl.rel = 'canonical';
        linkEl.href = canonical;
        document.head.appendChild(linkEl);
      }
    }

    // Open Graph tags
    const setMeta = (property, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[property="${property}"]`) || 
               document.querySelector(`meta[name="${property}"]`);
      if (el) {
        el.setAttribute('content', content);
      } else {
        const meta = document.createElement('meta');
        if (property.startsWith('og:')) {
          meta.setAttribute('property', property);
        } else {
          meta.setAttribute('name', property);
        }
        meta.content = content;
        document.head.appendChild(meta);
      }
    };

    setMeta('og:type', 'website');
    setMeta('og:title', fullTitle);
    setMeta('og:description', description);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);
  }, [fullTitle, description, keywords, canonical]);

  return null;
};

export default SEO;
